module.exports = __webpack_public_path__ + "static/media/3.93b330ff.svg";